module.exports = __webpack_public_path__ + "fonts/Nunito-ExtraBold.78bf361d.ttf";